import { isNetworkRequestInFlight } from 'apollo-client/core/networkStatus'

import { useProjectData } from '../useProjectData'
import { useGetStorageItems, GetStorageItemsProps } from './useGetStorageItems'

export const useProject = ({
  workspaceId,
  projectId,
  search,
  filters,
  types,
}: GetStorageItemsProps) => {
  const storageItemsQuery = useGetStorageItems({
    projectId,
    workspaceId,
    search,
    filters,
    types,
  })
  const projectQuery = useProjectData(workspaceId, projectId)
  const project = projectQuery.currentProject

  const loading =
    projectQuery.isInFlight ||
    isNetworkRequestInFlight(storageItemsQuery.networkStatus)

  const error = projectQuery.error || storageItemsQuery.error

  return {
    data: {
      project,
      storageItems: storageItemsQuery?.storageItems,
      breadcrumbs: projectQuery?.breadcrumbs,
    },
    loadMore: { storageItems: storageItemsQuery.fetchMore },
    loading,
    error,
    totalCount: storageItemsQuery.totalCounts,
  }
}
